/**
 * @desc 查询渠道平台映射关系
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<defs.tms.LogisticsPlatformResponseDto>;
export function request(
  params: API.tms.logisticsPlatformFacadeImpl.selectByLogistics.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/logisticsPlatform/selectByLogistics`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
